'use client';
export { ServerError as default } from '@/components/errors/server-error/server-error';
